<template lang="pug">
v-container(fluid).pt-0
  v-btn.ml-n2.px-2.mb-4(
    color="primary"
    text exact
    @click="$router.go(-1)"
  )
    v-icon(left) mdi-arrow-left
    span Назад
  h2.mb-4 Уведомления
  v-row.ma-0.mb-4
    v-btn-toggle(
      light
      mandatory
      :loading="loading"
      v-model="type" outlined small
    )
      v-btn(:value="TYPES.all" small :loading="loading" ) Не прочитанные
      v-btn(:value="TYPES.archive" outlined small :loading="loading") Архив
  v-btn.mb-4(
    :disabled="type === TYPES.archive || !notifications.length"
     color="secondary" text
    @click="readAll"
  ) Прочитать все
    v-icon(right) mdi-check
  v-list
    v-skeleton-loader(
      v-if="loading"
      type="list-item@3"
    )
    v-list-item(v-else-if="!notifications.length"  outlined)
      v-list-item-content Новых уведомлений не найдено...
    v-slide-x-transition(
      v-for="(n, idx) in notifications"
      :key="idx"
    )
      v-card.sdo-radius.mb-2.secondary.lighten-1(flat dark)
        v-card-subtitle.white--text.text-caption.d-flex.align-end.py-2
          strong От {{ n.created_at | dp('dd MMMM')}}
          v-spacer
          tooltip-wrap(
            :value="!n.wasRead"
            text="Отметить как прочитанное"
          )
            v-btn(icon small :disabled="n.wasRead" @click="readNotification([n.id])")
              v-icon {{n.wasRead ? 'mdi-eye-off' : 'mdi-eye' }}
        v-card-text.d-flex.flex-column(v-html="n.message")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TheNotifications',
  data() {
    return {
      type: 0,
      notifications: [],
      TYPES: {
        all: 0,
        archive: 1,
      },
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
  },
  watch: {
    type() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadNotifications();
    },
    async readAll() {
      await this.$api.notifications.readAllNotification();
      this.loadNotifications();
    },
    async readNotification(ids) {
      const payload = {
        ids,
      };
      this.notifications = this.notifications.filter((i) => !ids.includes(i.id));
      await this.$api.notifications.readNotification(payload);
      this.loadNotifications();
    },
    loadNotifications() {
      this.loading = true;
      return this.$rHandler(
        this.$api.notifications.index({
          params: {
            'search[read]': this.type,
          },
        }),
        ({ data }) => {
          this.notifications = data.data.map((i) => ({
            id: i.id,
            ...i.data,
            created_at: i.created_at,
            wasRead: !!i.read_at,
          }));
          if (!this.type && this.notifications.length) this.wasRead = false;
          this.loading = false;
          return data;
        },
      );
    },
  },
};
</script>
